import { motion } from "framer-motion";

interface ViewGroupProps {
	name: string;
	children?: React.ReactNode | React.ReactNode[];
}

export default function ViewGroup(props: ViewGroupProps) {
	return (
		<motion.div
			layout
			className="bg-[#FDFDFD]"
		>
			{/* <div className="my-3  flex h-full select-none items-center text-sm   text-gray-400 "> */}
			<div>
				{/* {props.icon} */}
				<div>
					<h2 className="text-sm text-black-50 font-semibold pt-3 pb-1">
						{props.name}
					</h2>
				</div>
			</div>
			<div className="flex flex-col gap-1">
				{props.children}
			</div>
		</motion.div>
	);
}
